<template>
    <div>
       <div class="login-container">
        <div class="alert alert-danger login-alert" v-if="error">
            <p>{{ error }}</p>
        </div>

            <div class="reset-welcome">
              Hello, {{ userObject.email }}. You must reset your password in order to continue.
            </div>

            <div class="form-group">
                <input id="firstName"
                        type="email"
                        name="firstName"
                        v-model="userInfo.firstName"
                        placeholder="First Name"
                        required >
            </div>
            <div class="form-group">
                <input id="lastName"
                        type="email"
                        name="lastName"
                        v-model="userInfo.lastName"
                        placeholder="Last Name"
                        required>
            </div>
            <div class="form-group">
                <input id="password"
                        type="password"
                        name="password"
                        placeholder="Password"
                        v-model="userInfo.password"
                        required
                        autofocus>
            </div>
            <div class="form-group">
                <input id="confirmPass"
                        type="password"
                        name="confirmPass"
                        placeholder="Confirm Password"
                        v-model="userInfo.confirmPass"
                        required>
            </div>
            <div class="form-group">
            <button class="sign-in-button"
                   v-bind:class="{ 'sign-in-button-disabled': loading }"
                   @click="submit()"
                :disabled="loading">
              {{ submitButtonText }}
            </button>
            </div>
    </div>

    </div>
</template>

<script>

export default {
  data() {
    return {
      userInfo: {
        firstName: '',
        lastName: '',
        password: '',
        confirmPass: '',
      },
      error: null,
      loading: false,
    };
  },
  mounted() {
    this.loading = false;
    this.error = null;
    this.userInfo.firstName = this.userObject.first_name;
    this.userInfo.lastName = this.userObject.last_name;
  },
  methods: {

    submit() {
      this.loading = true;
      this.error = null;
      const userInfo = {
        first_name: this.userInfo.firstName,
        last_name: this.userInfo.lastName,
        password: this.userInfo.password,
        password_confirmation: this.userInfo.confirmPass,
        email: this.userObject.email,
      };

      this.updateUser(userInfo);
    },
    updateUser(userInfo) {
      this.$http.put(`/user/${this.userObject.id}`, userInfo).then(function () {
        this.$emit('userResetPassword');
      },
      function (response) {
        this.loading = false;
        this.error = response.body.message;
      });
    },
  },
  computed: {
    submitButtonText() {
      if (this.loading) {
        return 'Updating your account ....';
      }
      return 'Submit';
    },
  },
  props: ['user-object'],

};
</script>

<style>
.reset-welcome {
  margin-top:-50px;
  width:100%;
  text-align: center;
  font-size: 16px;
  padding:10px;
}
</style>
